/**
 * @file cascader module
 * @author
 * title: string，名称
 * isMsgRequired: boolean，是否必填项
 * validCode：function，校验规则
 */
import React from 'react';

import LabelFormItem from '../LabelFormItem/index.tsx';
import Cascader from 'antd/lib/cascader';

import {cities} from '../../pages/attest/constants';
import {
    ExclamationCircleOutlined
} from '@ant-design/icons';
import './index.less';

interface Props {
    type: string;
    title: string;
    isMsgRequired: boolean;
    data: any;
    updateData: any;
    style: {};
    placeholder?:string;
}

export default function CascaderFormItem(props: Props) {
    const {
        type,
        title,
        isMsgRequired,
        data,
        updateData,
        style,
        placeholder
    } = props;

    const onCityChange = (value, selectedOptions) => {
        const address = selectedOptions.map(o => o.label).join(',');
        updateData({
            [type]: address,
            [type + 'Err']: ''
        });
    };
    return (
        <div className={'form-item-cascader'}>
            {title && <LabelFormItem isMsgRequired={isMsgRequired} title={title} />}
            <div className={'form-item-cascader-box'}>
                <Cascader
                    className={
                        data[type + 'Err']
                            ? 'form-item-cascader-content border-error'
                            : 'form-item-cascader-content'
                    }
                    value={data[type].length ? data[type].split(',') : []}
                    style={style}
                    options={cities}
                    onChange={onCityChange} placeholder={placeholder}></Cascader>
                {data[type + 'Err'] && <p className="form-item-cascader-err">
                    <ExclamationCircleOutlined style={{marginRight: '4px'}} />
                    {data[type + 'Err']}</p>}
            </div>
        </div>
    );
}
